import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

// Gerência (admin) da camada declarativa dos templates de estratégia no DB. Edita VALORES/presets,
// não a lógica (builders ficam em código). Ver project_templates_in_db.
const STRATEGIES_URL = getBaseUrl('/strategies/');

export async function getTemplateDefinitions() {
    return await appRequest.doGetRequest(`${STRATEGIES_URL}templates/manage`);
}

export async function updateTemplateDefinition(id, payload) {
    return await appRequest.doPatchRequest(`${STRATEGIES_URL}templates/manage/${id}`, payload);
}

// Parecer de IA (advisory) sobre uma condição editada. payload: { role, condition, defaultCondition?, templateName? }
export async function reviewCondition(payload) {
    return await appRequest.doPostRequest(`${STRATEGIES_URL}templates/review-condition`, payload);
}

// Fase 2d.2 gate e — GERA uma estratégia por IA (intenção → blueprint, roda gates schema+sim+advisory).
// payload: { intent, config? }. Retorna { blueprint, ok, gates:{schema,sim,advisory} }. NÃO salva.
export async function generateBlueprint(payload) {
    return await appRequest.doPostRequest(`${STRATEGIES_URL}templates/generate`, payload);
}

// Salva o blueprint (revisado pelo humano) como template. payload: { blueprint, name, description?, difficulty? }.
export async function saveGeneratedTemplate(payload) {
    return await appRequest.doPostRequest(`${STRATEGIES_URL}templates/generate/save`, payload);
}

// Fase 2d.4 — REFINA um template por IA. payload: { templateId, goal, config? }. Retorna { blueprint, ok,
// gates, source }. NÃO salva.
export async function refineBlueprint(payload) {
    return await appRequest.doPostRequest(`${STRATEGIES_URL}templates/refine`, payload);
}

// Atualiza o blueprint de um template não-sistema in-place. payload: { templateId, blueprint }.
export async function updateTemplateBlueprint(payload) {
    return await appRequest.doPostRequest(`${STRATEGIES_URL}templates/update-blueprint`, payload);
}
